<script>
export default {
  name: "ConfirmableButton",
  props: {
    caption: {
      type: String,
      default: "ボタンのキャプション"
    },
    size: {
      type: String,
      default: "md"
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "primary"
    },
    modalTitle: {
      type: String,
      default: "確認"
    },
    modalContent: {
      type: String,
      default: ""
    },
    modalPositiveColor: {
      type: String,
      default: "primary"
    },
    modalPositiveCaption: {
      type: String,
      default: "はい"
    },
    modalNegativeCaption: {
      type: String,
      default: "いいえ"
    }
  },
  data () {
    return {
      enableModal: false,
    }
  },
  methods: {

    /**
     * ネガティブボタン クリックイベント
     */
    negativeButtonClickEvent () {
      this.$emit('negative');
      this.enableModal = false;
    },

    /**
     * ポジティブボタン クリックイベント
     */
    positiveButtonClickEvent () {
      this.$emit('positive');
      this.enableModal = false;
    },
  }
}
</script>

<template>
  <v-dialog
    v-model="enableModal"
    width="500"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        :color="color"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
      >
        {{ caption }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dense flat :color="color" dark>
        <v-toolbar-title>{{ modalTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col>
            <p class="my-3">
              {{ modalContent }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="negativeButtonClickEvent"
        >
          {{ modalNegativeCaption }}
        </v-btn>
        <v-btn
          :color="modalPositiveColor"
          @click="positiveButtonClickEvent"
        >
          {{ modalPositiveCaption }}
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<style scoped lang="scss">

</style>
